import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import BiSpan from '../../../biLogger/Components/BiSpan';
import { BiEventType } from '../../../biLogger/constants';
import noop from '../../../utils/noop';
import { useFlag } from '../../../redux/flags/hooks';
import s from './UserSymbol.scss';
function useUserSymbolTranslation(userType) {
    var t = useTranslation().t;
    var newCoreEnabled = useFlag('core_badges');
    switch (userType) {
        case 'admin':
            return t('userSymbolsPopup.symbols.admin.title');
        case 'banned':
            return undefined;
        case 'beta':
            return t('userSymbolsPopup.symbols.beta.title');
        case 'buyer':
            return undefined;
        case 'group':
            return t('userSymbol.a11y.group.title');
        case 'hell':
            return t('userSymbolsPopup.symbols.hell.title');
        case 'hell-beta':
            return t('userSymbolsPopup.symbols.hell-beta.title');
        case 'premium':
            return t('userSymbolsPopup.symbols.premium.title');
        case 'regular':
            return undefined;
        case 'senior':
            return t('userSymbolsPopup.symbols.senior.title');
        case 'super':
            return t('userSymbol.a11y.superGroup.title');
        case 'volunteer':
            return t('userSymbolsPopup.symbols.volunteer.title');
        case 'core_access':
            if (newCoreEnabled) {
                return t('userSymbolsPopup.symbols.core_access.title');
            }
            return t('userSymbolsPopup.symbols.premium.title');
        case 'core_plus':
            if (newCoreEnabled) {
                return t('userSymbolsPopup.symbols.core_plus.title');
            }
            return t('userSymbolsPopup.symbols.premium.title');
        case 'core_pro':
            if (newCoreEnabled) {
                return t('userSymbolsPopup.symbols.core_pro.title');
            }
            return t('userSymbolsPopup.symbols.premium.title');
        default:
            return undefined;
    }
}
export var UserSymbol = function (_a) {
    var userType = _a.userType, className = _a.className, biData = _a.biData, _b = _a.openUserSymbolPopup, openUserSymbolPopup = _b === void 0 ? false : _b, _c = _a.pushUserSymbolsPopup, pushUserSymbolsPopup = _c === void 0 ? noop : _c, ariaHidden = _a["aria-hidden"];
    var label = useUserSymbolTranslation(userType);
    var newCoreEnabled = useFlag('core_badges');
    var isOldUserType = !(userType === 'core_access' ||
        userType === 'core_pro' ||
        userType === 'core_plus');
    var userTypeNewCore = newCoreEnabled || isOldUserType ? userType : 'premium';
    var spanProps = {
        className: classnames(s['symbol'], s[userTypeNewCore], className),
        style: openUserSymbolPopup ? { cursor: 'pointer' } : {},
        'aria-label': label,
        'aria-hidden': ariaHidden,
    };
    if (openUserSymbolPopup) {
        var biEventData = __assign(__assign({}, biData), { symbol: userTypeNewCore, evid: BiEventType.USER_SYMBOL_CLICK });
        var onClick = function (ev) {
            ev.preventDefault();
            // Only open the popup if we're not in an iframe
            if (window.self === window.top) {
                pushUserSymbolsPopup();
            }
        };
        return (React.createElement(BiSpan, __assign({}, spanProps, { biData: biEventData, onClick: onClick, stopPropagation: true })));
    }
    return React.createElement("span", __assign({}, spanProps));
};
UserSymbol.displayName = 'UserSymbol';
export default UserSymbol;
//# sourceMappingURL=UserSymbol.js.map